import api from "@/router/api"

export default {
    getAllSegments({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesSegmentsVhe.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_SEGMENTS', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener el segmento',
                })
            })
        })
    },
}
